import api from '../../utils/apiFetch';

const path = 'email-templates';

export default {
  postEmailTemplate: (payload) => api.post(`${path}/default`, payload),
  getEmailTemplates: () => api.get(`${path}/default`),
};
